export const GET_CAMPAIGN_ANALYSIS = "GET_CAMPAIGN_ANALYSIS"
export const GET_CAMPAIGN_ANALYSIS_SUCCESS = "GET_CAMPAIGN_ANALYSIS_SUCCESS"
export const GET_CAMPAIGN_ANALYSIS_ERROR = "GET_CAMPAIGN_ANALYSIS_ERROR"
export const GET_PING_DETAILS = "GET_PING_DETAILS"
export const GET_PING_DETAILS_SUCCESS = "GET_PING_DETAILS_SUCCESS"
export const GET_PING_DETAILS_ERROR = "GET_PING_DETAILS_ERROR"
export const EXPORT_CAMPAIGN_ANALYSIS = "EXPORT_CAMPAIGN_ANALYSIS"
export const EXPORT_CAMPAIGN_ANALYSIS_SUCCESS = "EXPORT_CAMPAIGN_ANALYSIS_SUCCESS"
export const EXPORT_CAMPAIGN_ANALYSIS_ERROR = "EXPORT_CAMPAIGN_ANALYSIS_ERROR"